var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { property, query, queryAssignedElements, state } from 'lit/decorators.js';
import { uniqueId } from 'lodash-es';
import { SdsContextMenuGroup } from '../../context-menu/group/sds-cm-group.lit';
import { SdsContextMenuSelectItem, } from '../../context-menu/item/sds-cm-select-item.lit';
import { SdsContextMenuItem, } from '../../context-menu/item/sds-cm-item.lit';
import { SdsContextMenuSkeletonItem } from '../../context-menu/item/sds-cm-skeleton-item.lit';
import { cleanMenuItemsFocus, focusNextItem, focusPreviousItem, getFocusedItem, getMenuItems, initMenuItemsFocus, scrollFocusedItemIfNeeded, } from '../menu-items-state-handler';
import { SimpleSelectRenderer } from '../simple-select/simple-select-renderer';
import { SelectRenderer } from './select-renderer';
import styles from '../sds-select.lit.scss';
import { SortInfo } from '../../shared/context-menu/item-search-sort';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * Control that represents select menu.
 *
 * @slot content - Slot for select menu's content.
 * Only `sds-cm-select-item` controls must be used here, other controls will be ignored.
 */
let SdsSelect = (() => {
    var _SdsSelect_disabled_accessor_storage, _SdsSelect_placeholder_accessor_storage, _SdsSelect_hint_accessor_storage, _SdsSelect_invalid_accessor_storage, _SdsSelect_errorMessage_accessor_storage, _SdsSelect_pagination_accessor_storage, _SdsSelect_simple_accessor_storage, _SdsSelect_maxWidth_accessor_storage, _SdsSelect_onlyIcon_accessor_storage, _SdsSelect_itemIcon_accessor_storage, _SdsSelect_selectInputValue_accessor_storage, _SdsSelect__value_accessor_storage, _SdsSelect_tooltip_accessor_storage, _SdsSelect_trigger_accessor_storage, _SdsSelect_contextMenu_accessor_storage, _SdsSelect_inputComponent_accessor_storage, _SdsSelect__selectItemsFromDoc_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-select')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    let _hint_decorators;
    let _hint_initializers = [];
    let _hint_extraInitializers = [];
    let _invalid_decorators;
    let _invalid_initializers = [];
    let _invalid_extraInitializers = [];
    let _errorMessage_decorators;
    let _errorMessage_initializers = [];
    let _errorMessage_extraInitializers = [];
    let _pagination_decorators;
    let _pagination_initializers = [];
    let _pagination_extraInitializers = [];
    let _simple_decorators;
    let _simple_initializers = [];
    let _simple_extraInitializers = [];
    let _maxWidth_decorators;
    let _maxWidth_initializers = [];
    let _maxWidth_extraInitializers = [];
    let _onlyIcon_decorators;
    let _onlyIcon_initializers = [];
    let _onlyIcon_extraInitializers = [];
    let _itemIcon_decorators;
    let _itemIcon_initializers = [];
    let _itemIcon_extraInitializers = [];
    let _selectInputValue_decorators;
    let _selectInputValue_initializers = [];
    let _selectInputValue_extraInitializers = [];
    let _set_value_decorators;
    let _tooltip_decorators;
    let _tooltip_initializers = [];
    let _tooltip_extraInitializers = [];
    let _trigger_decorators;
    let _trigger_initializers = [];
    let _trigger_extraInitializers = [];
    let _contextMenu_decorators;
    let _contextMenu_initializers = [];
    let _contextMenu_extraInitializers = [];
    let _inputComponent_decorators;
    let _inputComponent_initializers = [];
    let _inputComponent_extraInitializers = [];
    let _set_focused_decorators;
    let __selectItemsFromDoc_decorators;
    let __selectItemsFromDoc_initializers = [];
    let __selectItemsFromDoc_extraInitializers = [];
    var SdsSelect = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsSelect_disabled_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsSelect_placeholder_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _placeholder_initializers, '')));
            _SdsSelect_hint_accessor_storage.set(this, (__runInitializers(this, _placeholder_extraInitializers), __runInitializers(this, _hint_initializers, '')));
            _SdsSelect_invalid_accessor_storage.set(this, (__runInitializers(this, _hint_extraInitializers), __runInitializers(this, _invalid_initializers, false)));
            _SdsSelect_errorMessage_accessor_storage.set(this, (__runInitializers(this, _invalid_extraInitializers), __runInitializers(this, _errorMessage_initializers, '')));
            _SdsSelect_pagination_accessor_storage.set(this, (__runInitializers(this, _errorMessage_extraInitializers), __runInitializers(this, _pagination_initializers, false)));
            _SdsSelect_simple_accessor_storage.set(this, (__runInitializers(this, _pagination_extraInitializers), __runInitializers(this, _simple_initializers, false)));
            _SdsSelect_maxWidth_accessor_storage.set(this, (__runInitializers(this, _simple_extraInitializers), __runInitializers(this, _maxWidth_initializers, 400)));
            _SdsSelect_onlyIcon_accessor_storage.set(this, (__runInitializers(this, _maxWidth_extraInitializers), __runInitializers(this, _onlyIcon_initializers, false)));
            _SdsSelect_itemIcon_accessor_storage.set(this, (__runInitializers(this, _onlyIcon_extraInitializers), __runInitializers(this, _itemIcon_initializers, void 0)));
            _SdsSelect_selectInputValue_accessor_storage.set(this, (__runInitializers(this, _itemIcon_extraInitializers), __runInitializers(this, _selectInputValue_initializers, '')));
            _SdsSelect__value_accessor_storage.set(this, (__runInitializers(this, _selectInputValue_extraInitializers), ''));
            _SdsSelect_tooltip_accessor_storage.set(this, __runInitializers(this, _tooltip_initializers, ''));
            _SdsSelect_trigger_accessor_storage.set(this, (__runInitializers(this, _tooltip_extraInitializers), __runInitializers(this, _trigger_initializers, void 0)));
            _SdsSelect_contextMenu_accessor_storage.set(this, (__runInitializers(this, _trigger_extraInitializers), __runInitializers(this, _contextMenu_initializers, void 0)));
            _SdsSelect_inputComponent_accessor_storage.set(this, (__runInitializers(this, _contextMenu_extraInitializers), __runInitializers(this, _inputComponent_initializers, void 0)));
            this.selectItems = (__runInitializers(this, _inputComponent_extraInitializers), []);
            this.selectedItemIdentifier = '';
            this.filter = '';
            this._focused = false;
            _SdsSelect__selectItemsFromDoc_accessor_storage.set(this, __runInitializers(this, __selectItemsFromDoc_initializers, void 0));
            this._dropdownRenderer = __runInitializers(this, __selectItemsFromDoc_extraInitializers);
            this.lastScrollTopPosition = 0;
            this.onContentChange = () => {
                var _a;
                this.selectItems = [];
                if (this._selectItemsFromDoc.length !== 0) {
                    const isMenuOpened = (_a = this.contextMenu) === null || _a === void 0 ? void 0 : _a.opened;
                    if (!isMenuOpened) {
                        this.selectInputValue = '';
                    }
                    this._selectItemsFromDoc.forEach(item => {
                        this.setSelectItemIdentifierIfNeeded(item);
                        if (!this.selectItems.some(existingItem => existingItem.identifier === item.identifier)) {
                            if (item instanceof SdsContextMenuSelectItem) {
                                this.selectItemFirstUpdate(item, isMenuOpened);
                            }
                            if (item instanceof SdsContextMenuGroup) {
                                item.content.forEach(selectItem => {
                                    if (selectItem instanceof SdsContextMenuSelectItem) {
                                        this.setSelectItemIdentifierIfNeeded(selectItem);
                                        this.selectItemFirstUpdate(selectItem, isMenuOpened);
                                    }
                                });
                            }
                            this.selectItems.push(item);
                        }
                    });
                }
                else {
                    this.selectedItemIdentifier = '';
                }
                if (this._dropdownRenderer instanceof SelectRenderer) {
                    this.updateMenuContent();
                }
                this.requestUpdate(); // @ToDo check why we need this line;
                // steps open menu, type to have no data, check console
                // Element sds-button scheduled an update (generally because a property was set) after an update completed, causing a new update to be scheduled. This is inefficient and should be avoided unless the next update can only be scheduled as a side effect of the previous update. See https://lit.dev/msg/change-in-update for more information.
            };
            this.showContextMenu = () => {
                this._dropdownRenderer.openMenu();
            };
            this.handleSelectItemPropertyChange = (event) => {
                const eventDetails = event.detail;
                const targetItem = event.target;
                if (!eventDetails || !targetItem) {
                    return;
                }
                if (eventDetails.propertyName === 'selected') {
                    if (eventDetails.newValue) {
                        this.selectInputValue = targetItem.name;
                        this.tooltip = targetItem.tooltip;
                        if (targetItem.identifier) {
                            this.selectedItemIdentifier = targetItem.identifier;
                            this._value = targetItem.identifier;
                        }
                        this.selectItemStateHandler(item => {
                            if (item.identifier !== eventDetails.identifier) {
                                item.setSelectedSilently(false);
                            }
                        });
                        this.dispatchChangeEvent(this.selectedItemIdentifier);
                        this.dispatchSelectEvent(this.selectedItemIdentifier);
                    }
                }
                else if (eventDetails.propertyName === 'name') {
                    if (targetItem.selected && targetItem.identifier === this.selectedItemIdentifier) {
                        this.selectInputValue = targetItem.name;
                        this.dispatchInputEvent();
                    }
                }
            };
            this.handleSelectionChange = (event) => {
                var _a;
                const eventDetails = event.detail;
                const contextMenu = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('sds-context-menu');
                if (!contextMenu) {
                    return;
                }
                if (eventDetails.selected) {
                    const target = event.target;
                    this.selectInputValue = target.name;
                    this.tooltip = target.tooltip;
                    if (target.identifier) {
                        this.selectedItemIdentifier = target.identifier;
                        this._value = target.identifier;
                    }
                    this.selectItemStateHandler(item => {
                        if (item.identifier !== eventDetails.identifier) {
                            item.setSelectedSilently(false);
                        }
                    });
                    this.dispatchChangeEvent(this.selectedItemIdentifier);
                    this.dispatchSelectEvent(this.selectedItemIdentifier);
                }
                this._dropdownRenderer.hideMenu(true); // Focus input when selecting an item (user interaction)
            };
            this.handleMenuClose = (event) => {
                const composedPath = event.composedPath();
                const isInsideSdsSelect = composedPath.some(el => {
                    const isContextMenuGroup = el instanceof SdsContextMenuGroup;
                    const isThisSelect = el === this;
                    return isContextMenuGroup || isThisSelect;
                });
                if (!isInsideSdsSelect) {
                    this._dropdownRenderer.hideMenu(false); // Don't focus input when clicking outside
                }
            };
            this.handleKeyDown = (event) => {
                switch (event.code) {
                    case 'Tab':
                        // Prevent default tab behavior when menu is open
                        event.stopPropagation();
                        event.preventDefault();
                        break;
                    case 'Escape':
                        this._dropdownRenderer.hideMenu(true); // Focus input when closed via ESC key
                        event.stopPropagation();
                        break;
                    case 'Enter':
                    case 'NumpadEnter':
                        this.handleEnterKeydown(event);
                        event.stopPropagation();
                        break;
                    case 'ArrowUp':
                        this.handleArrowUp();
                        event.stopPropagation();
                        event.preventDefault();
                        break;
                    case 'ArrowDown':
                        this.handleArrowDown();
                        event.stopPropagation();
                        event.preventDefault();
                        break;
                }
            };
            this.handleScroll = () => {
                const menu = this.contextMenu.getMenu();
                if (this.lastScrollTopPosition < menu.scrollTop &&
                    2 * menu.offsetHeight + menu.scrollTop >= menu.scrollHeight) {
                    this.dispatchLoadMoreEvent();
                }
                this.lastScrollTopPosition = menu.scrollTop;
            };
            this.handleStopPropagation = (event) => {
                event.stopPropagation();
            };
            this.addEventListeners = () => {
                var _a, _b;
                document.addEventListener('keydown', this.handleKeyDown);
                document.addEventListener('mouseup', this.handleMenuClose);
                window.addEventListener('resize', this.handleMenuClose);
                this.contextMenu.addEventListener('click', this.handleStopPropagation);
                (_b = (_a = this.contextMenu.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-context-menu')) === null || _b === void 0 ? void 0 : _b.addEventListener('scroll', this.handleScroll);
            };
            this.removeEventListeners = () => {
                var _a, _b;
                document.removeEventListener('keydown', this.handleKeyDown);
                document.removeEventListener('mouseup', this.handleMenuClose);
                window.removeEventListener('resize', this.handleMenuClose);
                this.contextMenu.removeEventListener('click', this.handleStopPropagation);
                (_b = (_a = this.contextMenu.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-context-menu')) === null || _b === void 0 ? void 0 : _b.removeEventListener('scroll', this.handleScroll);
            };
        }
        /**
         * True if the select is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsSelect_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsSelect_disabled_accessor_storage, value, "f"); }
        /**
         * The placeholder of this select's input.
         * @attr
         */
        get placeholder() { return __classPrivateFieldGet(this, _SdsSelect_placeholder_accessor_storage, "f"); }
        set placeholder(value) { __classPrivateFieldSet(this, _SdsSelect_placeholder_accessor_storage, value, "f"); }
        /**
         * Hint for this select's input
         * @attr
         */
        get hint() { return __classPrivateFieldGet(this, _SdsSelect_hint_accessor_storage, "f"); }
        set hint(value) { __classPrivateFieldSet(this, _SdsSelect_hint_accessor_storage, value, "f"); }
        /**
         * True if this select is invalid.
         * @attr
         */
        get invalid() { return __classPrivateFieldGet(this, _SdsSelect_invalid_accessor_storage, "f"); }
        set invalid(value) { __classPrivateFieldSet(this, _SdsSelect_invalid_accessor_storage, value, "f"); }
        /**
         * The error message of this select, in case there is a validation error.
         * @attr
         */
        get errorMessage() { return __classPrivateFieldGet(this, _SdsSelect_errorMessage_accessor_storage, "f"); }
        set errorMessage(value) { __classPrivateFieldSet(this, _SdsSelect_errorMessage_accessor_storage, value, "f"); }
        /**
         * True if select is used for pagination.
         * @attr
         */
        get pagination() { return __classPrivateFieldGet(this, _SdsSelect_pagination_accessor_storage, "f"); }
        set pagination(value) { __classPrivateFieldSet(this, _SdsSelect_pagination_accessor_storage, value, "f"); }
        /**
         * Enables simplified styling or behavior for the select component.
         * Use this attribute to adjust the select's appearance for streamlined user interfaces.
         *
         * @attr {boolean} simple - True if the component is in simplified mode.
         */
        get simple() { return __classPrivateFieldGet(this, _SdsSelect_simple_accessor_storage, "f"); }
        set simple(value) { __classPrivateFieldSet(this, _SdsSelect_simple_accessor_storage, value, "f"); }
        /**
         * Indicates whether an option is currently selected within the select component.
         * This is derived from value.
         */
        get selected() {
            return !!this._value;
        }
        /**
         * Sets the maximum width of the select component, allowing the component to
         * adjust its width based on user interface requirements.
         *
         * @attr {number} max-width - The maximum width of the select component in pixels.
         */
        get maxWidth() { return __classPrivateFieldGet(this, _SdsSelect_maxWidth_accessor_storage, "f"); }
        set maxWidth(value) { __classPrivateFieldSet(this, _SdsSelect_maxWidth_accessor_storage, value, "f"); }
        /**
         * Determines if the select component should display icons only, without text labels.
         * Useful for creating compact or visually focused layouts.
         *
         * @attr {boolean} only-icon - True if only icons should be displayed.
         */
        get onlyIcon() { return __classPrivateFieldGet(this, _SdsSelect_onlyIcon_accessor_storage, "f"); }
        set onlyIcon(value) { __classPrivateFieldSet(this, _SdsSelect_onlyIcon_accessor_storage, value, "f"); }
        get itemIcon() { return __classPrivateFieldGet(this, _SdsSelect_itemIcon_accessor_storage, "f"); }
        set itemIcon(value) { __classPrivateFieldSet(this, _SdsSelect_itemIcon_accessor_storage, value, "f"); }
        get selectInputValue() { return __classPrivateFieldGet(this, _SdsSelect_selectInputValue_accessor_storage, "f"); }
        set selectInputValue(value) { __classPrivateFieldSet(this, _SdsSelect_selectInputValue_accessor_storage, value, "f"); }
        get _value() { return __classPrivateFieldGet(this, _SdsSelect__value_accessor_storage, "f"); }
        set _value(value) { __classPrivateFieldSet(this, _SdsSelect__value_accessor_storage, value, "f"); }
        get value() {
            return this._value;
        }
        set value(value) {
            this._value = value;
            this.selectedItemIdentifier = value;
            this.selectItemStateHandler(item => {
                if (item.identifier === value || item.value === value) {
                    item.setSelectedSilently(true);
                    item.focused = true;
                    this.selectInputValue = item.name;
                    this.filter = '';
                }
                else {
                    item.setSelectedSilently(false);
                    item.focused = false;
                }
            });
            this.dispatchInputEvent();
            this.dispatchChangeEvent(value);
        }
        get tooltip() { return __classPrivateFieldGet(this, _SdsSelect_tooltip_accessor_storage, "f"); }
        set tooltip(value) { __classPrivateFieldSet(this, _SdsSelect_tooltip_accessor_storage, value, "f"); }
        get trigger() { return __classPrivateFieldGet(this, _SdsSelect_trigger_accessor_storage, "f"); }
        set trigger(value) { __classPrivateFieldSet(this, _SdsSelect_trigger_accessor_storage, value, "f"); }
        get contextMenu() { return __classPrivateFieldGet(this, _SdsSelect_contextMenu_accessor_storage, "f"); }
        set contextMenu(value) { __classPrivateFieldSet(this, _SdsSelect_contextMenu_accessor_storage, value, "f"); }
        get inputComponent() { return __classPrivateFieldGet(this, _SdsSelect_inputComponent_accessor_storage, "f"); }
        set inputComponent(value) { __classPrivateFieldSet(this, _SdsSelect_inputComponent_accessor_storage, value, "f"); }
        get focused() {
            return this._focused;
        }
        set focused(value) {
            this._focused = value;
            if (this.inputComponent) {
                this.inputComponent.focused = value;
                if (value) {
                    this.inputComponent.getInput().focus();
                }
                else {
                    this.inputComponent.getInput().blur();
                }
            }
        }
        get _selectItemsFromDoc() { return __classPrivateFieldGet(this, _SdsSelect__selectItemsFromDoc_accessor_storage, "f"); }
        set _selectItemsFromDoc(value) { __classPrivateFieldSet(this, _SdsSelect__selectItemsFromDoc_accessor_storage, value, "f"); }
        willUpdate(_changedProperties) {
            if (_changedProperties.has('simple')) {
                this._dropdownRenderer = this.simple
                    ? new SimpleSelectRenderer(this)
                    : new SelectRenderer(this);
            }
            this._dropdownRenderer.willUpdate(_changedProperties);
        }
        async firstUpdated() {
            await this.updateComplete;
            this._dropdownRenderer.firstUpdated();
        }
        selectItemCustomClassesHandler() {
            let hasSelectedItem = false;
            this.selectItemStateHandler(item => {
                if (item.selected) {
                    hasSelectedItem = true;
                }
            });
            this.selectItemStateHandler(item => {
                var _a, _b, _c, _d;
                if (hasSelectedItem) {
                    (_b = (_a = item.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-cm-item')) === null || _b === void 0 ? void 0 : _b.classList.add('sds-cm-item--has-right-space');
                }
                else {
                    (_d = (_c = item.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.sds-cm-item')) === null || _d === void 0 ? void 0 : _d.classList.remove('sds-cm-item--has-right-space');
                }
            });
        }
        sortItems() {
            var _a;
            return (_a = this.selectItems) === null || _a === void 0 ? void 0 : _a.map(item => {
                if (!(item instanceof SdsContextMenuSkeletonItem)) {
                    const sortInfo = item.applySearchAndReturnSortInfo(this.filter);
                    return {
                        sortInfo: sortInfo,
                        item: item,
                    };
                }
                else {
                    return {
                        sortInfo: SortInfo.LAST,
                        item: item,
                    };
                }
            }).filter(meta => {
                const isFound = meta.sortInfo.isFound();
                meta.item.style.display = isFound ? '' : 'none';
                return isFound;
            }).sort((a, b) => SortInfo.compareFn(a.sortInfo, b.sortInfo));
        }
        updateMenuContent() {
            var _a;
            this.selectItemCustomClassesHandler();
            //TODO: sortItems() returns sorted array but doesn't apply visual order to rendered menu items. Need to make sorting visible in UI.
            this.sortItems();
            // Check if context menu exists before proceeding
            if (!this.contextMenu) {
                return;
            }
            // Only reset focus if the menu is not open or if there's no focused item
            const items = getMenuItems(this.contextMenu, true);
            const currentFocusedIndex = items.findIndex(item => item.focused);
            const selectedIndex = items.findIndex(item => item.selected);
            // If menu is open and there's a focused item that's different from selected, don't reset focus
            if (((_a = this.contextMenu) === null || _a === void 0 ? void 0 : _a.opened) &&
                currentFocusedIndex !== -1 &&
                currentFocusedIndex !== selectedIndex) {
                return;
            }
            cleanMenuItemsFocus(this.contextMenu);
            initMenuItemsFocus(this.contextMenu);
        }
        render() {
            return this._dropdownRenderer.render();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        handleEnterKeydown(event) {
            let itemWasSelected = false;
            this.selectItemStateHandler(item => {
                if (item.focused && !item.disabled) {
                    item.setSelectedSilently(true);
                    this.selectInputValue = item.name;
                    this.tooltip = item.tooltip;
                    if (item.identifier) {
                        this.selectedItemIdentifier = item.identifier;
                        this._value = item.identifier;
                    }
                    itemWasSelected = true;
                }
            });
            this.selectItemStateHandler(item => {
                if (item.identifier !== this.selectedItemIdentifier) {
                    item.setSelectedSilently(false);
                }
            });
            this.dispatchSelectEvent(this.selectedItemIdentifier);
            this.dispatchChangeEvent(this.selectedItemIdentifier);
            if (itemWasSelected) {
                this._dropdownRenderer.hideMenu(true);
            }
            event.preventDefault();
            event.stopPropagation();
        }
        handleArrowDown() {
            // Use original context menu navigation
            const nextItem = focusNextItem(this.contextMenu);
            if (nextItem) {
                this.updateAriaActiveDescendant(nextItem);
            }
            this.requestUpdate();
            scrollFocusedItemIfNeeded(this.contextMenu);
        }
        handleArrowUp() {
            // Use original context menu navigation
            const nextItem = focusPreviousItem(this.contextMenu);
            if (nextItem) {
                this.updateAriaActiveDescendant(nextItem);
            }
            this.requestUpdate();
            scrollFocusedItemIfNeeded(this.contextMenu);
        }
        /**
         * Sets the ariaActiveDescendantElement property on the input element.
         * This is used for cross-shadow-root accessibility communication.
         *
         * The ariaActiveDescendantElement property allows the input to reference
         * a menu item element directly (instead of using string IDs), which works
         * across shadow DOM boundaries where traditional aria-activedescendant fails.
         *
         * @param element - The menu item element to reference, or null to clear
         * @private
         */
        setAriaActiveDescendantElement(element) {
            var _a;
            const inputElement = (_a = this.inputComponent) === null || _a === void 0 ? void 0 : _a.getInput();
            if (inputElement) {
                // Use bracket notation to access the non-standard DOM property
                // ariaActiveDescendantElement is a modern browser feature for aria-activedescendant
                inputElement['ariaActiveDescendantElement'] = element;
            }
        }
        /**
         * Updates the aria-activedescendant reference to point to the specified menu item.
         * This enables screen readers to announce the currently navigated item while
         * keeping focus on the input for typing/searching.
         *
         * @param menuItem - The menu item element that is currently focused/navigated
         * @public
         */
        updateAriaActiveDescendant(menuItem) {
            if (menuItem) {
                this.setAriaActiveDescendantElement(menuItem);
            }
        }
        /**
         * Clears the aria-activedescendant reference, typically when the menu closes
         * or when no item is focused.
         *
         * @public
         */
        clearAriaActiveDescendant() {
            this.setAriaActiveDescendantElement(null);
        }
        /**
         * Sets the initial aria-activedescendant reference when the menu opens.
         * This points to whichever item is initially focused (usually the selected item
         * or the first item).
         *
         * @public
         */
        setInitialAriaActiveDescendant() {
            const focusedItem = getFocusedItem(this.contextMenu);
            if (focusedItem) {
                this.updateAriaActiveDescendant(focusedItem);
            }
        }
        selectItemFirstUpdate(selectItem, isMenuOpened) {
            if (selectItem.identifier) {
                selectItem.focused = false;
                if (this._value !== '') {
                    if (this._value === selectItem.identifier) {
                        selectItem.setSelectedSilently(true);
                        this.selectedItemIdentifier = selectItem.identifier;
                        this.tooltip = selectItem.tooltip;
                        if (!isMenuOpened) {
                            this.selectInputValue = selectItem.name;
                        }
                    }
                    else if (selectItem.selected) {
                        selectItem.setSelectedSilently(false);
                    }
                }
                else {
                    if (selectItem.selected) {
                        this.selectedItemIdentifier = selectItem.identifier;
                        this._value = selectItem.identifier;
                        this.tooltip = selectItem.tooltip;
                        if (!isMenuOpened) {
                            this.selectInputValue = selectItem.name;
                        }
                    }
                }
            }
            selectItem.addEventListener(SdsContextMenuSelectItem.CM_ITEM_SELECTION_CHANGE, this.handleSelectionChange);
            selectItem.addEventListener(SdsContextMenuItem.CM_ITEM_PROPERTY_CHANGE, this.handleSelectItemPropertyChange);
        }
        selectItemStateHandler(callback) {
            this.selectItems.forEach(item => {
                if (item instanceof SdsContextMenuSelectItem) {
                    callback(item);
                }
                if (item instanceof SdsContextMenuGroup) {
                    item.content.forEach(groupItem => {
                        if (groupItem instanceof SdsContextMenuSelectItem) {
                            callback(groupItem);
                        }
                    });
                }
            });
        }
        setSelectItemIdentifierIfNeeded(item) {
            if (!item.identifier) {
                item.identifier = uniqueId('select-item-');
            }
        }
        dispatchSelectEvent(identifier) {
            this.dispatchEvent(new CustomEvent(SdsSelect.SELECTED_EVENT, {
                detail: {
                    identifier: identifier,
                },
                bubbles: false,
                composed: false,
            }));
        }
        dispatchChangeEvent(value) {
            this.dispatchEvent(new CustomEvent(SdsSelect.CHANGE_EVENT, {
                detail: {
                    value: value,
                },
                bubbles: false,
                composed: false,
            }));
        }
        dispatchLoadMoreEvent() {
            this.dispatchEvent(new CustomEvent(SdsSelect.LOAD_MORE_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
        dispatchMenuOpenEvent() {
            this.dispatchEvent(new CustomEvent(SdsSelect.OPEN_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
        dispatchMenuCloseEvent() {
            this.dispatchEvent(new CustomEvent(SdsSelect.CLOSE_EVENT, {
                bubbles: false,
                composed: false,
            }));
        }
        dispatchBlurEvent() {
            this.dispatchEvent(new CustomEvent(SdsSelect.BLUR_EVENT, {
                bubbles: true,
                composed: true,
            }));
        }
        dispatchFocusEvent() {
            this.dispatchEvent(new CustomEvent(SdsSelect.FOCUS_EVENT, {
                bubbles: true,
                composed: true,
            }));
        }
        dispatchInputEvent() {
            this.dispatchEvent(new CustomEvent(SdsSelect.INPUT_EVENT, {
                detail: {
                    value: this.selectInputValue,
                },
                bubbles: false,
                composed: false,
            }));
            this.dispatchEvent(new CustomEvent(SdsSelect.NATIVE_INPUT_EVENT, {
                detail: {
                    value: this.selectInputValue,
                },
                bubbles: true,
                composed: true,
            }));
        }
        focus() {
            if (this.inputComponent) {
                this.inputComponent.focus();
                this.focused = true;
                this.dispatchFocusEvent();
            }
        }
        blur() {
            if (this.inputComponent) {
                this.inputComponent.blur();
                this.focused = false;
                this.dispatchBlurEvent();
            }
        }
        click() {
            if (this.simple) {
                if (this.trigger instanceof HTMLElement) {
                    this.trigger.focus();
                    const renderer = this._dropdownRenderer;
                    if (typeof renderer.toggleContextMenu === 'function') {
                        renderer.toggleContextMenu();
                    }
                }
            }
            else if (this.inputComponent) {
                const inputElement = this.inputComponent.getInput();
                if (inputElement) {
                    inputElement.focus();
                    inputElement.click();
                }
                this.inputComponent.setCursorToEnd();
                this.showContextMenu();
            }
        }
    };
    _SdsSelect_disabled_accessor_storage = new WeakMap();
    _SdsSelect_placeholder_accessor_storage = new WeakMap();
    _SdsSelect_hint_accessor_storage = new WeakMap();
    _SdsSelect_invalid_accessor_storage = new WeakMap();
    _SdsSelect_errorMessage_accessor_storage = new WeakMap();
    _SdsSelect_pagination_accessor_storage = new WeakMap();
    _SdsSelect_simple_accessor_storage = new WeakMap();
    _SdsSelect_maxWidth_accessor_storage = new WeakMap();
    _SdsSelect_onlyIcon_accessor_storage = new WeakMap();
    _SdsSelect_itemIcon_accessor_storage = new WeakMap();
    _SdsSelect_selectInputValue_accessor_storage = new WeakMap();
    _SdsSelect__value_accessor_storage = new WeakMap();
    _SdsSelect_tooltip_accessor_storage = new WeakMap();
    _SdsSelect_trigger_accessor_storage = new WeakMap();
    _SdsSelect_contextMenu_accessor_storage = new WeakMap();
    _SdsSelect_inputComponent_accessor_storage = new WeakMap();
    _SdsSelect__selectItemsFromDoc_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsSelect");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _disabled_decorators = [property({ type: Boolean })];
        _placeholder_decorators = [property({ type: String })];
        _hint_decorators = [property({ type: String })];
        _invalid_decorators = [property({ type: Boolean })];
        _errorMessage_decorators = [property({ type: String, attribute: 'error-message' })];
        _pagination_decorators = [property({ type: Boolean })];
        _simple_decorators = [property({ type: Boolean })];
        _maxWidth_decorators = [property({ type: Number, attribute: 'max-width' })];
        _onlyIcon_decorators = [property({ type: Boolean, attribute: 'only-icon' })];
        _itemIcon_decorators = [property({ attribute: false })];
        _selectInputValue_decorators = [state()];
        _set_value_decorators = [property({ type: String, reflect: true })];
        _tooltip_decorators = [property({ attribute: false })];
        _trigger_decorators = [query('#trigger')];
        _contextMenu_decorators = [query('sds-context-menu')];
        _inputComponent_decorators = [query('sds-input-select')];
        _set_focused_decorators = [property({ type: Boolean })];
        __selectItemsFromDoc_decorators = [queryAssignedElements({ flatten: false })];
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
        __esDecorate(_classThis, null, _hint_decorators, { kind: "accessor", name: "hint", static: false, private: false, access: { has: obj => "hint" in obj, get: obj => obj.hint, set: (obj, value) => { obj.hint = value; } }, metadata: _metadata }, _hint_initializers, _hint_extraInitializers);
        __esDecorate(_classThis, null, _invalid_decorators, { kind: "accessor", name: "invalid", static: false, private: false, access: { has: obj => "invalid" in obj, get: obj => obj.invalid, set: (obj, value) => { obj.invalid = value; } }, metadata: _metadata }, _invalid_initializers, _invalid_extraInitializers);
        __esDecorate(_classThis, null, _errorMessage_decorators, { kind: "accessor", name: "errorMessage", static: false, private: false, access: { has: obj => "errorMessage" in obj, get: obj => obj.errorMessage, set: (obj, value) => { obj.errorMessage = value; } }, metadata: _metadata }, _errorMessage_initializers, _errorMessage_extraInitializers);
        __esDecorate(_classThis, null, _pagination_decorators, { kind: "accessor", name: "pagination", static: false, private: false, access: { has: obj => "pagination" in obj, get: obj => obj.pagination, set: (obj, value) => { obj.pagination = value; } }, metadata: _metadata }, _pagination_initializers, _pagination_extraInitializers);
        __esDecorate(_classThis, null, _simple_decorators, { kind: "accessor", name: "simple", static: false, private: false, access: { has: obj => "simple" in obj, get: obj => obj.simple, set: (obj, value) => { obj.simple = value; } }, metadata: _metadata }, _simple_initializers, _simple_extraInitializers);
        __esDecorate(_classThis, null, _maxWidth_decorators, { kind: "accessor", name: "maxWidth", static: false, private: false, access: { has: obj => "maxWidth" in obj, get: obj => obj.maxWidth, set: (obj, value) => { obj.maxWidth = value; } }, metadata: _metadata }, _maxWidth_initializers, _maxWidth_extraInitializers);
        __esDecorate(_classThis, null, _onlyIcon_decorators, { kind: "accessor", name: "onlyIcon", static: false, private: false, access: { has: obj => "onlyIcon" in obj, get: obj => obj.onlyIcon, set: (obj, value) => { obj.onlyIcon = value; } }, metadata: _metadata }, _onlyIcon_initializers, _onlyIcon_extraInitializers);
        __esDecorate(_classThis, null, _itemIcon_decorators, { kind: "accessor", name: "itemIcon", static: false, private: false, access: { has: obj => "itemIcon" in obj, get: obj => obj.itemIcon, set: (obj, value) => { obj.itemIcon = value; } }, metadata: _metadata }, _itemIcon_initializers, _itemIcon_extraInitializers);
        __esDecorate(_classThis, null, _selectInputValue_decorators, { kind: "accessor", name: "selectInputValue", static: false, private: false, access: { has: obj => "selectInputValue" in obj, get: obj => obj.selectInputValue, set: (obj, value) => { obj.selectInputValue = value; } }, metadata: _metadata }, _selectInputValue_initializers, _selectInputValue_extraInitializers);
        __esDecorate(_classThis, null, _set_value_decorators, { kind: "setter", name: "value", static: false, private: false, access: { has: obj => "value" in obj, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _tooltip_decorators, { kind: "accessor", name: "tooltip", static: false, private: false, access: { has: obj => "tooltip" in obj, get: obj => obj.tooltip, set: (obj, value) => { obj.tooltip = value; } }, metadata: _metadata }, _tooltip_initializers, _tooltip_extraInitializers);
        __esDecorate(_classThis, null, _trigger_decorators, { kind: "accessor", name: "trigger", static: false, private: false, access: { has: obj => "trigger" in obj, get: obj => obj.trigger, set: (obj, value) => { obj.trigger = value; } }, metadata: _metadata }, _trigger_initializers, _trigger_extraInitializers);
        __esDecorate(_classThis, null, _contextMenu_decorators, { kind: "accessor", name: "contextMenu", static: false, private: false, access: { has: obj => "contextMenu" in obj, get: obj => obj.contextMenu, set: (obj, value) => { obj.contextMenu = value; } }, metadata: _metadata }, _contextMenu_initializers, _contextMenu_extraInitializers);
        __esDecorate(_classThis, null, _inputComponent_decorators, { kind: "accessor", name: "inputComponent", static: false, private: false, access: { has: obj => "inputComponent" in obj, get: obj => obj.inputComponent, set: (obj, value) => { obj.inputComponent = value; } }, metadata: _metadata }, _inputComponent_initializers, _inputComponent_extraInitializers);
        __esDecorate(_classThis, null, _set_focused_decorators, { kind: "setter", name: "focused", static: false, private: false, access: { has: obj => "focused" in obj, set: (obj, value) => { obj.focused = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, __selectItemsFromDoc_decorators, { kind: "accessor", name: "_selectItemsFromDoc", static: false, private: false, access: { has: obj => "_selectItemsFromDoc" in obj, get: obj => obj._selectItemsFromDoc, set: (obj, value) => { obj._selectItemsFromDoc = value; } }, metadata: _metadata }, __selectItemsFromDoc_initializers, __selectItemsFromDoc_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsSelect = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.CHANGE_EVENT = 'change';
    _classThis.CLICK_EVENT = 'click';
    _classThis.FOCUS_EVENT = 'focus';
    _classThis.NATIVE_INPUT_EVENT = 'input';
    _classThis.BLUR_EVENT = 'blur';
    _classThis.SELECTED_EVENT = 'sds.select.selected';
    _classThis.CLEARED_EVENT = 'sds.select.cleared';
    _classThis.INPUT_EVENT = 'sds.select.input';
    _classThis.LOAD_MORE_EVENT = 'sds.select.load.more';
    _classThis.OPEN_EVENT = 'sds.select.opened';
    _classThis.CLOSE_EVENT = 'sds.select.closed';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsSelect = _classThis;
})();
export { SdsSelect };
